import React, {Component} from 'react';
import {Button, Modal, Form, Grid, Message, Icon, Header} from 'semantic-ui-react';

import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {ticketClientDialogActions} from "../../actions/TicketClientDialogActions";
import helpers from "../../functions/helpers";
import ClientSelect from "../sale/ClientSelect";
import CustomDivider from "../extras/CustomDivider";
import TicketData from "../../data/TicketData";
import {FormattedNumber} from "react-intl";
import {selectClient} from "../../actions/ClientSelectActions";
import PaymentDialog from "../my_bisttro/PaymentDialog";
import {paymentDialog} from "../../actions/PaymentDialogActions";
import {totalSale} from "../../actions/SaleTotalAction";

class TicketClientDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            ticket: null,
            tickets:[],
            options:[],
            sale: {
                id:null,
                discount:0
            }
        };

        this.props.paymentDialog(false);
    }

    componentWillMount(){
        TicketData.listAll().then(tickets => {
            this.setState({tickets, options:helpers.mapTickets(tickets)});
        })
    }

    handleClose = () => {
        this.props.selectClient(null);
        this.props.ticketClientDialog({open:false, ticket:null});
        this.setState({ticket:null});
    };

    handleTicketChange = (value) => {
        let ticket = this.state.tickets.find(ticket => ticket.id===value);
        this.setState({ticket});
    };

    saleTicket = () => {
        if(!this.props.select_client){
            this.props.showToast({open:true, message:'Por favor seleccione un cliente!', type:'error'});
        }else if(!this.state.ticket){
            this.props.showToast({open:true, message:'Por favor seleccione una tiquetera!', type:'error'});
        }else{
            this.props.totalSale({
                amount: 0,
                balance: this.state.ticket.price,
                discount: 0,
                payments: 0,
                taxes: [],
                total_sale: this.state.ticket.price,
                client: this.props.select_client,
            });
            this.props.paymentDialog({modal:true, ticket:this.state.ticket.id});
        }
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.ticket_client_dialog.open} onClose={this.handleClose}>
                    <Modal.Header>Vender Tiquetera</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Grid stackable>
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <Form.Field>
                                                {this.props.select_client ? null:<label>{this.props.select_client}Cliente</label>}
                                                <ClientSelect client={this.state.ticket} />
                                            </Form.Field>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Form.Select label='Tiquetera'
                                                         search
                                                         options={this.state.options}
                                                         onChange={(e, { value }) => this.handleTicketChange(value)}
                                                         placeholder='Tiquetera' />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                            <CustomDivider/>
                            {this.state.ticket ? <Message icon>
                                    <Icon name='ticket' />
                                    <Message.Content>
                                        <Message.Header>{this.state.ticket.name}</Message.Header>
                                        {this.state.ticket.has_expiration ? <p>Días de caducidad: {this.state.ticket.expiration_days}</p>:null}
                                        <Message.List items={helpers.mapProductTickets(this.state.ticket.products)} />
                                        <Message.Content>
                                            <br/>
                                            Valor:
                                            <Header as='h2' color='orange'>
                                                $<FormattedNumber value={this.state.ticket.price} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                                            </Header>
                                        </Message.Content>
                                    </Message.Content>
                                </Message>:
                                <Message
                                    icon='warning sign'
                                    header='Información'
                                    content='Por favor seleccione una tiquetera'
                                />
                            }
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='money bill alternate outline'
                                labelPosition='left'
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                content='Vender'
                                onClick={this.saleTicket}/>
                    </Modal.Actions>
                </Modal>
                <PaymentDialog sale={this.state.sale} type='ticket'/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ticket_client_dialog: state.get('ticket_client_dialog'),
        select_client: state.get('select_client'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data){
            dispatch(showToast(data))
        },
        selectClient(data){
            dispatch(selectClient(data))
        },
        ticketClientDialog(data){
            dispatch(ticketClientDialogActions(data))
        },
        paymentDialog(data){
            dispatch(paymentDialog(data))
        },
        totalSale(total) {
            dispatch(totalSale(total))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketClientDialog);


// WEBPACK FOOTER //
// ./src/components/services/TicketClientDialog.js